/* RESPONSIBLE TEAM: team-ai-agent */
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

export default class FinAIAgentAnalyzeUnresolvedQuestionsRoute extends Route {
  @service declare intl: IntlService;
  @service declare router: RouterService;
  @service declare appService: $TSFixMe;

  get titleToken() {
    return this.intl.t('ai-agent.analyze.unresolved-questions');
  }

  beforeModel() {
    if (this.appService.app.canSeeAiInsightsBeta) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.analyze.optimize-fin');
      return;
    }
  }
}
